import React from 'react';

export const LOGO_URL = 'https://customer-assets-m6fa6gv7.emergentagent.net/job_premium-pet-food-dev/artifacts/tdhhopoi_Logo-NUTRIPET%20GOURTMET-alimento-premium-mascotas-Bogot%C3%A1.png';

const SIZES = {
  sm: 'w-9 h-9',
  md: 'w-11 h-11',
  lg: 'w-14 h-14',
  xl: 'w-20 h-20',
};

/**
 * Reusable brand logo. `variant`:
 *  - 'mark' → only the image (no text)
 *  - 'lockup' → image + wordmark (default in headers)
 */
const Logo = ({ size = 'md', variant = 'mark', className = '', invert = false }) => {
  const dimension = SIZES[size] || SIZES.md;
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Nutripet Gourmet"
        className={`${dimension} object-contain shrink-0`}
        loading="eager"
      />
      {variant === 'lockup' && (
        <div className="flex flex-col leading-none">
          <span
            className={`font-display font-bold text-lg ${invert ? 'text-white' : 'text-[#1C1917]'}`}
          >
            Nutripet Gourmet
          </span>
          <span
            className={`text-[10px] tracking-[0.2em] uppercase ${invert ? 'text-white/60' : 'text-[#57534E]'}`}
          >
            Premium Pet Nutrition
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
